<template>
  <Main>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-card class="pa-5" shaped color="#F8F8FF">
            <strong>AAM - ADJUST INCENTIVE SUMMARY</strong>
            <v-row>
              <v-col cols="6">
                <v-card class="pa-2">
                  <v-row dense>
                    <v-col cols="3" align-self="center">PERIOD</v-col>
                    <v-col cols="9">
                      <v-menu
                        v-model="openPeriod"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                          color="red darken-1"
                            v-model="period"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            solo
                            hide-details
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="period" type="month" @input="openPeriod = false" color="red darken-1"></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="3" align-self="center">POSITION</v-col>
                    <v-col cols="9">
                      <v-autocomplete
                        v-model="position"
                        :items="salesList"
                        item-text="POSITION_CODE"
                        item-value="POSITION_CODE"
                        class="mx-1"
                        style="width: 99%;"
                        @change="onCustomerSelected($event, index)"
                        solo
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="3" align-self="center">BRANCH</v-col>
                    <v-col cols="9">
                        <v-autocomplete
                        v-model="orgID"
                        :items="VSELECT_BRANCH"
                        item-text="BRANCH_CODE"
                        item-value="ORG_ID"
                        class="mx-1"
                        style="width: 99%;"
                        solo
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  
                  <v-row dense>
                    <v-col cols="3"></v-col>
                    <v-col cols="9">
                      <v-btn @click="searchAdjustIncentive" color="warning" block>FIND</v-btn>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
           
            <v-row class="mt-2">
              <v-col md="12">
                 <v-data-table
                  :headers="dtHeaderSummary"
                  :items="dtItemSummary"
                  :loading="dtLoading"
                  loading-text="Fetching Data..."
                  :hide-default-footer="true"
                   :hide-default-header="false"
                  class="elevation-1"
                ></v-data-table>
              </v-col>
                <v-row class="mt-2">
                   <v-col md="6">
                            <v-btn color="warning" @click="downloadCSV()">Export Excel</v-btn>
                  </v-col>
                  <v-col class="text-right" cols="6">
                    <v-text-field
                      color="red darken-1"
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Search"                      
                  :search="search"
                      single-line
                      hide-details
                      class="pa-0"
                    ></v-text-field>
                  </v-col>
               </v-row>
               <v-col md=12>
                 <v-data-table
                  :headers="dtHeaderDetail"
                  :items="dtItemDetail"
                  :search="search"
                  :loading="dtLoading"
                  loading-text="Fetching Data..."
                  class="elevation-1"
                ></v-data-table>
              </v-col>
              
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- SNACKBAR -->
    <v-snackbar v-model="isShowSnackbar" top>{{ snackbarText }}</v-snackbar>
    <!-- LOADING OVERLAY -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </Main>
</template>

<script>
import Main from "@/Main.vue";
import moment from "moment";
import XLSX from "xlsx";

export default {
  components: {
    Main
  },
  data() {
    return {
      salesName: JSON.parse(localStorage.getItem('userData')).POSITION_CODE,
      dtLoading: false,
      search: "",
      isLoading: false,
      isShowSnackbar: false,
      snackbarText: "",
      period: moment().format("YYYY-MM"),
      position: "",
      openPeriod: false,
      summary: [],
      detail: [],
      salesList:[],
      orgID: JSON.parse(localStorage.getItem('userData')).ORG_ID,
      dtHeaderSummary: [
        { text: "PERIOD", value: "period" },
        { text: "POSITION", value: "POSITION_TO" },
        { text: "SALESMAN NAME", value: "SALESMAN_NAME" },
        { text: "CLAIM PENGAJUAN", value: "SUM_APPROVE" },
        { text: "CLAIM REJECT", value: "SUM_REJECT" },
        { text: "NET CLAIM", value: "NET_CLAIM" }
      ],
      dtItemSummary: [],
      dtHeaderDetail: [
        { text: "CUSTOMER", value: "CUSTOMER_NAME" },
        { text: "INVOICE", value: "INVOICE_NUMBER" },
        { text: "ITEM", value: "PRODUCT_DESC" },
        { text: "AMOUNT", value: "VALUE_ADJUST" },
        { text: "FROM", value: "POSITION_FROM" },
        { text: "TO", value: "POSITION_TO" },
        { text: "REASON", value: "NOTES" },
        { text: "STATUS", value: "STATUS" }
      ],
      dtItemDetail: [],
      VSELECT_BRANCH: [],
    };
  },
  mounted() {	
		this.populateSalesList();
    this.getBranch();
	},
  methods: {
      getBranch() {
            this.dtLoading = true;
            this.$http
                .get("/target/selectBranch", {
                  headers: {
                    "api-key": this.$apiKey
                  }
                })
                .then(res => {
                    this.dtLoading = false;
                    const data = res.data.data;
                    if(this.orgID==81){
                      this.VSELECT_BRANCH = data;
                    }else{
                        let orgId = this.orgID;
                        var fltBranch = data.filter(function (el){
                          return el.ORG_ID == orgId
                        }
                      );
                      this.VSELECT_BRANCH = fltBranch
                    }
                })
                .catch(err => {
                    this.dtLoading = false;
                    this.showSnackbar(err.toString());
                });
        },
    searchAdjustIncentive() {
      this.isLoading = true;
      const splitPeriod = this.period.split("-");
      const month = splitPeriod[1];
      const year = splitPeriod[0];
      const body = {
        month,
        year,
        position: this.position,
        orgID: this.orgID
      };
      console.log('body ', body);
      this.$http
        .post("/adjust-incentive-summary/selectAdjustIncentive", body, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then(res => {
          this.isLoading = false;
          const { data } = res.data;
          console.log('data ', data)
          if (data.summary) {
            var position =this.position
          
            let summary = data.summary;
            // summary.period = `${summary.YearID}-${summary.MonthID}`;
            // let sumReject = summary.SUM_REJECT;
            // let sumApprove = summary.SUM_APPROVE;
            // summary.SUM_REJECT =  parseInt(sumReject).toLocaleString('en-US');
            // summary.SUM_APPROVE =  parseInt(sumApprove).toLocaleString('en-US');

            // let netClaim = sumApprove - sumReject;
            // summary.NET_CLAIM = parseInt(netClaim).toLocaleString('en-US');
            // if(position===''){              
            //   summary.SALESMAN_NAME = '';
            // }else{
            //   summary.SALESMAN_NAME = xName[0].EMPLOYEE_NAME;
            // }
            summary.forEach((val, index) => {
              let positionTo = summary[index].POSITION_TO;
              var xName = this.salesList.filter(function (el)
                {
                  return el.POSITION_CODE == positionTo
                }
              );
              summary[index].SALESMAN_NAME = xName[0].EMPLOYEE_NAME;

              let sumReject = summary[index].SUM_REJECT;
              let sumApprove = summary[index].SUM_APPROVE;
              summary[index].SUM_REJECT =  parseInt(sumReject).toLocaleString('en-US');
              summary[index].SUM_APPROVE =  parseInt(sumApprove).toLocaleString('en-US');

              let netClaim = sumApprove - sumReject;
              
              summary[index].NET_CLAIM = parseInt(netClaim).toLocaleString('en-US');;
              summary[index].period = `${summary[index].YearID}-${summary[index].MonthID}`;
            });
            this.dtItemSummary = summary;

            let dataDetailEdit = data.detail;
            // dataDetailEdit.forEach((val, index) => {
            //   dataDetailEdit[index].VALUE_ADJUST = parseInt(dataDetailEdit[index].VALUE_ADJUST).toLocaleString('en-US');
            // });
            this.dtItemDetail = dataDetailEdit;
          } else {
            this.dtItemSummary = [];
            this.dtItemDetail = [];
          }
        })
        .catch(err => {
          this.isLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    populateSalesList() {
      let data = {
				orgID: this.orgID
			};
      console.log('data ', data)
			this.isLoading = true;
      
			this.$http
				.post('/adjust-incentive/getSalesRepStructure', data, {
          headers: {
            "api-key": this.$apiKey
          }
        })
				.then((res) => {
					this.isLoading = false;
					const { data } = res.data;
					this.salesList = data;
          console.log('this.salesList ', this.salesList)
				})
				.catch((err) => {
					this.isLoading = false;
					this.showSnackbar(err.toString());
				});
		},
    onCustomerSelected(event,index){
      this.salesList.push({POSITION_CODE:""});
    },
    showSnackbar(text) {
      this.snackbarText = text;
      this.isShowSnackbar = true;
    },
    downloadCSV() {       

          const workBook = XLSX.utils.book_new(); // create a new blank book
          const workSheet = XLSX.utils.json_to_sheet(this.dtItemDetail);
          XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1"); // add the worksheet to the book
          XLSX.writeFile(workBook, "Detail Incentive.xlsx"); // initiate a file download in browser
    }
  }
};
</script>
